module.exports = __webpack_public_path__ + "static/media/doortittle2.fcab94f2.jpeg";